import {Pipe, PipeTransform} from "@angular/core";

@Pipe({
  name: 'concatenate'
})
export class ConcatenatePipe implements PipeTransform {

  transform(value: Array<string>, arg0: string, arg1: string): any {
    if(!value || value.length === 1) {
      return value;
    }
    else {
      let formattedStr = '';
      const delimiter = arg0 || ', ';
      const wordLink = arg1 || 'and';

      value.forEach((v, index) => {
        if(index === value.length - 2) {
          formattedStr += v + ' ' + wordLink + ' ';
        }
        else if(index === value.length - 1) {
          formattedStr += v + '.';
        }
        else {
          formattedStr += v + delimiter;
        }
      });

      return formattedStr;
    }
  }
}
